module.exports = __webpack_public_path__ + "static/media/pg09.91aa4660.jpg";